import {
    includes as _includes,
    get as _get
} from '@lodash';
import IEventDto from '@core/mappers/offer/dtos/IEventDto';
import Match from '@core/models/offer/Match';
import OddMapper from '@core/mappers/offer/OddMapper';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import RuleMapper from '@core/mappers/offer/RuleMapper';
import MetaDataMapper from '@core/mappers/offer/MetaDataMapper';
import MatchResultMapper from '@core/mappers/offer/MatchResultMapper';
import { EventCategory, OfferStatus, OfferType } from '@core/models/offer/enums';
import config from '@config';

const metaDataMapper: MetaDataMapper = new MetaDataMapper();
const ruleMapper: RuleMapper = new RuleMapper();
const oddMapper: OddMapper = new OddMapper();
const matchResultMapper: MatchResultMapper = new MatchResultMapper();

const excludedStreamTournaments = config.countrySpecific.sport.excludedStreamTournaments || [];

export default class EventMapper extends AbstractMapper<IEventDto, Match> {
    createTargetObject(dto: IEventDto) {
        const e: Match = new Match();
        const isLive = _includes(
            [OfferStatus.active, OfferStatus.block],
            _get(dto.oss, OfferType.live)
        );
        e.id = dto.mi;
        e.offerId = dto.ofi;
        e.specialOfferId = dto.soi ? parseInt(dto.soi.replace(/[^0-9\.]+/g, ''), 10) : null;
        e.fullName = dto.mn;
        e.sportId = dto.si;
        e.tournamentId = dto.ti;
        e.date = this.toDate(dto.utcDate) as Date;
        e.utcDate = dto.utcDate; // forwarded when saving ticket, to save on string -> Date -> string conversion
        e.matchTimestamp = dto.mts;
        e.oddCount = isLive ? dto.cnts.odds['2'] : dto.cnts.odds['1'];
        e.marketCount = isLive ? dto.cnts.bgs['2'] : dto.cnts.bgs['1'];
        e.team1Id = dto.ti1;
        e.team2Id = dto.ti2;
        e.eventCategory = dto.eventCategory || null;
        e.enteringCodes = dto.enteringCodes;
        e.code = dto.mc;
        e.incrementId = dto.incrementId || 0;
        e.betRadarId = dto.bri;
        e.categoryId = dto.ci;
        e.sportOrder = dto.so;
        e.categoryOrder = dto.co;
        e.tournamentOrder = dto.to;
        e.offerStatus = dto.oss;
        e.specialTournamentOrder = dto.to2;
        e.isGoingToBeInLiveBetting = dto.hslv;
        e.rules = dto.mrls ? ruleMapper.map(dto.mrls, true) : [];
        e.metaData = dto.mtd ? metaDataMapper.map(dto.mtd, false) : undefined;
        if (dto.tf) {
            e.tournamentFooter = dto.tf;
        }
        if (dto.mf) {
            e.matchFooter = dto.mf;
        }
        let odds: any[] = [];
        if (dto.odds) {
            odds = isLive
                ? dto.odds.filter((o) => o.osi === OfferType.live)
                : dto.odds.filter((o) => o.osi === OfferType.preEvent);
        }
        const isSpecialFromSportOffer = e.eventCategory === EventCategory.OUTRIGHT || e.code === 0;

        e.setOdds(oddMapper.map(odds, isSpecialFromSportOffer));

        e.setOddResults(dto.oddsResults ? oddMapper.map(dto.oddsResults!, true) : []);
        e.tournamentCategoryName = dto.tn2;

        e.matchResults = matchResultMapper.createTargetObject({
            matchResults: dto.mres,
            metaData: dto.mtd,
        });
        const previousResult = dto.mpr ? dto.mpr.split(':') : '';
        e.team1PreviousResult = previousResult[0] || '';
        e.team2PreviousResult = previousResult[1] || '';
        e.tournamentName2 = dto.tn2;
        if (config.countrySpecific.sport.isStreamAvailable && !excludedStreamTournaments.includes(e.tournamentId)) {
            e.hasStream = !!dto.hstr;
        }
        e.streamInfo = dto.hstr || {};
        return e;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/offer/EventMapper.ts